import React, { useContext, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Typography, Card, Box } from '@mui/material';
import LoopIcon from '@mui/icons-material/Loop';
import IconButton from '../../components/IconButton';
import { conf, Relationship, FieldType } from 'src/config';
import { Scope as ExplorerScope, ExplorerContext } from '../../../../explorer/components/Entity';
import * as types from '../../../types';
import { goto } from '../../../actions';
import { inError } from '../../../utils';
import _ from 'lodash';


const RelCard: React.FC<{
    rel: Relationship,
    inverse: boolean,
    entity: types.Entity,
    parentLocator: types.Locator,
    renderActions: (entity: types.Entity) => React.ReactElement,
    loopIndex: number,
    index?: number,
}> = ({
    rel,
    inverse,
    entity,
    parentLocator,
    renderActions,
    loopIndex,
    index = 0,
}) => {
        const dispatch = useDispatch();
        const explorerScope: ExplorerScope = useContext(ExplorerContext)!;
        const { entity: parent, state: { stack, entities } } = explorerScope;
        const loop = loopIndex > -1;

        let errored: boolean = useMemo(
            () => {
                if (entity != null) {
                    const id = entity.values['_id'].toString();
                    const name = inverse ? rel.resource : rel.related;
                    const locator: types.Locator = { name, id };
                    return inError(entities, locator, [{
                        rel,
                        resource: inverse ? locator : parentLocator,
                        related: inverse ? parentLocator : locator,
                    }]);
                }
                return false;
            },
            [entity, rel, entities]
        );

        const loopAction = <IconButton onClick={() => dispatch(goto(loopIndex))}>
            <LoopIcon fontSize='small' />
        </IconButton>;

        return (
            <Card
                variant='outlined'
                sx={{
                    display: 'flex',
                    mt: index == 0 ? 0 : 0.4,
                    borderColor: theme => errored ? theme.palette.error.main : theme.palette.grey[500],
                    bgcolor: loop ? theme => theme.palette.grey[100] : undefined,
                }}
            >

                <Box sx={{
                    display: 'flex',
                    flexGrow: 1,
                    pl: 2
                }}>
                    {
                        entity && _.entries(conf.getEditableFields(entity.morph ?? (inverse ? rel.resource : rel.related)))
                            .filter(([name, field]) => {
                                return field.type === FieldType.BOOLEAN || (entity?.attrs[name] ?? entity?.values[name])
                            })
                            .map(([name, field]) => (
                                <Typography
                                    key={name}
                                    variant='body1'
                                    sx={{
                                        mr: 1,
                                        color: theme => theme.palette.grey[700],
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <b style={{ paddingRight: '0.3em' }}>{`${name}:`}</b>
                                    <span>{`${entity?.values[name] ?? entity?.attrs[name]};`}</span>
                                </Typography>
                            ))
                    }
                </Box>
                {
                    loop ? loopAction : renderActions(entity)
                }
            </Card>
        )
    }

export default RelCard;
